<template>
    <div class="mid_scroll_content">
        <section class="depoist_fund  pb-5">

            <div class="row justify-content-center">
                <div class="col-10">
                    <p class="text-center mb-5">Please note that {{$env_var.productName}} conducts full identity checks before enabling an account for the services it provides. And unless stated otherwise, all the information below is required.</p>

                    <div class="row">
                        <div class="col-5">
                            <div class="form-group text-center cap_verify">
                                <input type="text" class="mb-3 form-control" placeholder="psharma1@finvasia.in" name="" required="" disabled="">
                                <label class="text-left labeltext active">Email Address</label>
                                <span class="mt-3 green msg"> <feather type="check"></feather> Verify Email </span>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="form-group text-center cap_verify cap_notverify">
                                <input type="text" class="mb-3 form-control" name="" placeholder="9780930939" required="" disabled="">
                                <label class="text-left labeltext active">Mobile Number</label>
                                <span class="mt-3 red msg"> <feather type="x-circle"></feather> Not Verified </span>
                            </div>
                        </div>
                        <div class="col-2 verifyButton">
                            <input type="submit" class="cap_btn green pl-3 pr-3 large_btn" value="Verify Now" name="" required="">
                        </div>

                    </div>
                </div>

            </div>
        </section>
        <section class="depoist_fund  pb-5">
            <div class="section_title">
                <h5>Full Personal Details</h5>
            </div>
            <div class="row justify-content-center">
                <div class="col-10">
                    <form acttion="#">
                        <div class="row">
                            <div class="col-4">
                                <div class="form-group">
                                    <input type="text" class="form-control" name="first_name" v-validate="'required'">
                                    <label class="labeltext">First Name</label>
									<span v-show="submitted && errors.has('first_name')" class="text-danger">The first name is required</span>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <input type="text" class="form-control" name="middle_name" v-validate="'required'">
                                    <label class="labeltext">Middle Name</label>
									<span v-show="submitted && errors.has('middle_name')" class="text-danger">The middle name is required</span>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <input type="text" class="form-control" name="last_name" v-validate="'required'">
                                    <label class="labeltext">Last Name</label>
									<span v-show="submitted && errors.has('last_name')" class="text-danger">The last name is required</span>
                                </div>
                            </div>
                            <div class="col-5">
                                <div class="form-group dob">
                                    <input type="text" class="form-control" name="dob" v-validate="'required'">
                                    <label class="labeltext">DOB (DD/MM/YYYY)</label>
                                    <feather class="dropAngle" type="chevron-down"></feather>
									<span v-show="submitted && errors.has('dob')" class="text-danger">This is required</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <input type="text" class="form-control" name="full_adrs" v-validate="'required'">
                                            <label class="labeltext">Full address</label>
											<span v-show="submitted && errors.has('full_adrs')" class="text-danger">The address is required</span>
                                        </div>
                                    </div>
                                    <div class="col-6 pr-5">
                                        <div class="form-group">
                                            <input type="text" class="form-control" name="city" v-validate="'required'">
                                            <label class="labeltext">City</label>
											<span v-show="submitted && errors.has('city')" class="text-danger">The City is required</span>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <input type="text" class="form-control" name="state" v-validate="'required'">
                                            <label class="labeltext">State</label>
											<span v-show="submitted && errors.has('state')" class="text-danger">The State is required</span>
                                        </div>
                                    </div>
                                    <div class="col-6 pr-5">
                                        <div class="form-group">
                                            <input type="text" class="form-control" name="country" v-validate="'required'">
                                            <label class="labeltext">Country</label>
											<span v-show="submitted && errors.has('country')" class="text-danger">The Country is required</span>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <input type="text" class="form-control" name="area_code" v-validate="'required'">
                                            <label class="labeltext">Area Code</label>
											<span v-show="submitted && errors.has('area_code')" class="text-danger">This is required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4 mb-4">
                            <div class="col-7">
                                <h4 class="cap_subtitle menuColor">Are you political exposed person? *</h4>
                            </div>
                            <div class="col-5">
                                <select class="form-control" name="exposed" data-placeholder="Select Political Exposed Person">
                                    <option value="">Yes</option>
                                    <option value="">No</option>
                                </select>
								<span v-show="submitted && errors.has('exposed')" class="text-danger">This is required</span>
								
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-7">
                                <h4 class="cap_subtitle menuColor">Account Type</h4>
                            </div>
                            <div class="col-5">
                                <select class="form-control" name="acc_type" data-placeholder="Select Account Type">
                                    <option value="">Individual</option>
                                    <option value="">Corporate</option>
                                    <option value="">Self Managed Super Fund</option>
                                </select>
								<span v-show="submitted && errors.has('acc_type')" class="text-danger">This is required</span>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-12 mt-4 mb-1">
                                <p>Please ensure your details correctly match any documents you intend to submit.</p>
                            </div>
                        </div>
                        <div class="row align-items-center mb-4">
                            <div class="col-7">
                                <h4 class="cap_subtitle menuColor">PLEASE Upload a photo ID with Date of Birth</h4>
                                <p class="m-0">*Valid Driver’s License, Govt Issued ID, passport.</p>
                            </div>
                            <div class="col-5">
                                <div class="form-group customUpload m-0">
                                    <form class="form">
                                        <div class="upload-btn-wrapper-include">
                                            <button class="btn">Upload</button>
                                            <input type="file" name="myfile" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col-7">
                                <h4 class="cap_subtitle menuColor">PLEASE Upload a photo OF ADDRESS</h4>
                                <p class="m-0">*Utility Bill, Bank Statement, Tax Receipts.</p>
                            </div>
                            <div class="col-5">
                                <div class="form-group customUpload m-0">
                                    <form class="form">
                                        <div class="upload-btn-wrapper-include">
                                            <button class="btn">Upload</button>
                                            <input type="file" name="myfile" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>
        <section class="depoist_fund  pb-5">
            <div class="section_title">
                <h5>Verification Photo</h5>
            </div>
            <div class="row justify-content-center align-items-center">
                <div class="col-7">
                    <ul>
                        <p>All users are required to upload a Verification photo. This is just part of the numerous techniques and systems we employ to ensure the legitimacy of our users.</p>
                        <p>Please upload a photo of yourself holding a hand written paper with the statement below:</p>
                        <p>I, [Your Full Name], submit this photo to confirm my identity and my secret code is C4C6H. </p>
                        <p>[Your Signature]</p>
                        <p>Please ensure that the your face, code and signature is clearly visible</p>
                    </ul>
                    <div class="secret_code text-center rounded p-2">
                        <h3 class="m-0">SECRET CODE</h3>
                        C4C6H
                    </div>
                </div>
                <div class="col-3">
                    <div class="form-group">
                        <form class="form">
                            <div class="file-upload-wrapper" data-text="Upload Your Photo">
                                <input name="file-upload-field" type="file" class="file-upload-field" value="">
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    </div>

</template>

<script>
export default {
    name: 'verification',
    data() {
        return {

			submitted: false,
        }
    },
	methods: {
		creditCardFunc(){
			const _that = this
			_that.submitted = true;
			_that.$validator.validate().then(valid => {
				if (valid) {
					let input_json={
						'globalParams' :{

						},
						'localParams' :{ "parameter" : _that }
					}
					// _that.apiFunc(input_json)
				}
			});
		}
	},
	created(){
	
		this.pageName('Account Verification')
	}
}
</script>



// WEBPACK FOOTER //
// src/components/website/user/verification.vue